import { render, staticRenderFns } from "./pageModel1.vue?vue&type=template&id=3b98d534"
import script from "./pageModel1.vue?vue&type=script&lang=js"
export * from "./pageModel1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports